var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgUserCheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-check-16px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99992 2.75C4.94137 2.75 4.08325 3.60812 4.08325 4.66667C4.08325 5.72521 4.94137 6.58333 5.99992 6.58333C7.05847 6.58333 7.91659 5.72521 7.91659 4.66667C7.91659 3.60812 7.05847 2.75 5.99992 2.75ZM2.58325 4.66667C2.58325 2.77969 4.11295 1.25 5.99992 1.25C7.88689 1.25 9.41659 2.77969 9.41659 4.66667C9.41659 6.55364 7.88689 8.08333 5.99992 8.08333C4.11295 8.08333 2.58325 6.55364 2.58325 4.66667ZM15.494 5.43558C15.8057 5.70834 15.8373 6.18217 15.5645 6.49389L13.2311 9.16056C13.0944 9.31677 12.8991 9.40935 12.6916 9.41625C12.4842 9.42316 12.2831 9.34377 12.1363 9.197L10.803 7.86366C10.5101 7.57077 10.5101 7.0959 10.803 6.803C11.0959 6.51011 11.5708 6.51011 11.8637 6.803L12.6301 7.56948L14.4357 5.50611C14.7084 5.19439 15.1822 5.16281 15.494 5.43558ZM1.25072 10.2507C1.89147 9.60997 2.76051 9.25 3.66667 9.25H8.33333C9.23949 9.25 10.1085 9.60997 10.7493 10.2507C11.39 10.8915 11.75 11.7605 11.75 12.6667V14C11.75 14.4142 11.4142 14.75 11 14.75C10.5858 14.75 10.25 14.4142 10.25 14V12.6667C10.25 12.1583 10.0481 11.6708 9.68862 11.3114C9.32918 10.9519 8.84167 10.75 8.33333 10.75H3.66667C3.15834 10.75 2.67082 10.9519 2.31138 11.3114C1.95193 11.6708 1.75 12.1583 1.75 12.6667V14C1.75 14.4142 1.41421 14.75 1 14.75C0.585786 14.75 0.25 14.4142 0.25 14V12.6667C0.25 11.7605 0.609969 10.8915 1.25072 10.2507Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user-check.990c26a0.svg";
export { ForwardRef as ReactComponent };